import yup from 'utils/yup';

export const areaFormSceneSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  countryId: yup.string().required('Country is required').nullable(),
  coords: yup.string().required('Coordinates is required'),
  address: yup.string().required('Address is required'),
});
